const form = {
  formId: "new-user-form",
  formField: {
    nameOfProductionBusinessActivities: {
      name: "nameOfProductionBusinessActivities",
      label: "[01a] Tên hoạt động sản xuất kinh doanh:",
      type: "text",
      placeholder: "Hoạt động sản xuất kinh doanh thông thường",
      errorMsg: "Vui lòng nhập tên hoạt động sản xuất",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01b] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[06] Tên tổ chức/cá nhân nhận chuyển nhượng:",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label:
        "[07] Mã số thuế/số chứng minh nhân dân/số căn cước công dân (đối với các nhân chưa có mã số thuế):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address: {
      name: "address",
      label: "[08a] Địa chỉ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    addressCity: {
      name: "addressCity",
      label: "[08d] Tỉnh/Thành phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Tỉnh/Thành phố",
    },
    addressDistrict: {
      name: "addressDistrict",
      label: "[08c] Quận/Huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Quận/Huyện",
    },
    addressWard: {
      name: "addressWard",
      label: "[08b] Phường/Xã:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Phường/Xã",
    },
    addressEstate: {
      name: "addressEstate",
      label: "[09a] Số nhà/đường phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    addressCityEstate: {
      name: "addressCityEstate",
      label: "[09d] Tỉnh/Thành phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Tỉnh/Thành phố",
    },
    addressDistrictEstate: {
      name: "addressDistrictEstate",
      label: "[09c] Quận/Huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Quận/Huyện",
    },
    addressWardEstate: {
      name: "addressWardEstate",
      label: "[09b] Phường/Xã:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Phường/Xã",
    },
    contract: {
      name: "contract",
      label: "Theo hợp đồng bất động sản: Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số",
    },
    contractDate: {
      name: "contractDate",
      label: "Ngày",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    notarizedDate: {
      name: "notarizedDate",
      label: "có công chứng hoặc chứng thực tại UBND phường (xã) xác nhận ngày",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[10] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "",
    },
    taxAgentId: {
      name: "taxAgentId",
      label: "[11] Mã số thuế:",
      type: "text",
      placeholder: "",
    },
    //--------------//
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
